<template>
  <div>
    <!-- NW設定共通 -->
    <v-row class="mt-3">
      <v-col>
        <v-row>
          <v-col>
            <h3>NW設定共通</h3>
          </v-col>
        </v-row>
        <!-- エンドユーザー名 -->
        <v-row>
          <v-col>
            <app-label-group
              label="エンドユーザ名"
              :value="nwSettingDetail.endUserName"
            />
          </v-col>
        </v-row>
        <!-- NW設定確認時のみ表示 -->
        <template v-if="isShowBandwidthInfo">
          <!-- 品目 -->
          <v-row>
            <v-col>
              <app-label-group
                label="品目"
                :value="
                  nwSettingDetail.bandwidthType === 'BEST_EFFORT'
                    ? 'ベストエフォート'
                    : '帯域確保'
                "
              />
            </v-col>
          </v-row>
          <!-- 契約帯域 -->
          <v-row>
            <v-col>
              <app-label-group label="契約帯域">
                <template #value>
                  <div class="ml-3">
                    <span
                      v-if="nwSettingDetail.bandwidthType === 'BEST_EFFORT'"
                    >
                      1Gbps
                    </span>
                    <span v-else>
                      {{ nwSettingDetail.bandwidth!.value
                      }}{{
                        $filter.enumTo(
                          nwSettingDetail.bandwidth!.unit,
                          "bandwidth_unit"
                        )
                      }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>

        <!-- 端末割当アドレス(IPv4) : 契約情報がIPV6以外の場合に表示 -->
        <template v-if="cpaContractInfo.ipAddressType !== 'IPV6'">
          <v-row>
            <v-col>
              <app-label-group label="端末割当アドレス(IPv4)">
                <template #value>
                  <div class="ml-3">
                    <span
                      class="mr-4 ipv4-display"
                      v-for="(poolIp, index) in sortedUeIpAllocationIpv4List"
                      :key="index"
                    >
                      {{ poolIp }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>

        <!-- 端末割当アドレス(IPv6) : 契約情報がIPV4以外の場合に表示 -->
        <template v-if="cpaContractInfo.ipAddressType !== 'IPV4'">
          <v-row>
            <v-col>
              <app-label-group label="端末割当アドレス(IPv6)">
                <template #value>
                  <div class="ml-3">
                    <span
                      class="mr-4 ipv6-display"
                      v-for="(
                        poolIp, index
                      ) in nwSettingDetail.ueIpAllocationIpv6List"
                      :key="index"
                    >
                      {{ poolIp }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>

    <!-- NW設定(ACT/SBY) -->
    <v-row class="mt-3">
      <!-- NW設定(ACT) -->
      <v-col cols="6">
        <v-row>
          <v-col>
            <h3>NW設定(Act)</h3>
          </v-col>
        </v-row>
        <!-- WAN IPアドレス(IPv4) : 契約情報がIPV6以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV6' &&
            nwSettingDetail.networkIpSettingAct
          "
        >
          <v-row>
            <v-col>
              <app-label-group label="WAN IPアドレス(IPv4)">
                <template #value>
                  <small>GW対向ルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingAct.wanIpv4Pe }}
                  </div>
                  <small>GWルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingAct.wanIpv4Gw }}
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>
        <!-- WAN IPアドレス(IPv6) : 契約情報がIPV4以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV4' &&
            nwSettingDetail.networkIpSettingAct
          "
        >
          <v-row>
            <v-col>
              <app-label-group label="WAN IPアドレス(IPv6)">
                <template #value>
                  <small>GW対向ルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingAct.wanIpv6Pe }}
                  </div>
                  <small>GWルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingAct.wanIpv6Gw }}
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>
        <!-- DNS IPアドレス(IPv4) : 契約情報がIPV6以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV6' &&
            nwSettingDetail.networkIpSettingAct
          "
        >
          <v-row>
            <v-col>
              <app-label-group
                label="DNS IPアドレス(IPv4)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.networkIpSettingAct.dnsIpv4,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>
        <!-- DNS IPアドレス(IPv6) : 契約情報がIPV4以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV4' &&
            nwSettingDetail.networkIpSettingAct
          "
        >
          <v-row>
            <v-col>
              <app-label-group
                label="DNS IPアドレス(IPv6)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.networkIpSettingAct.dnsIpv6,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>
      </v-col>

      <!-- NW設定(SBY) -->
      <v-col cols="6">
        <v-row>
          <v-col>
            <h3>NW設定(Sby)</h3>
          </v-col>
        </v-row>
        <!-- WAN IPアドレス(IPv4) : 契約情報がIPV6以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV6' &&
            nwSettingDetail.networkIpSettingSby
          "
        >
          <v-row>
            <v-col>
              <app-label-group label="WAN IPアドレス(IPv4)">
                <template #value>
                  <small>GW対向ルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingSby.wanIpv4Pe }}
                  </div>
                  <small>GWルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingSby.wanIpv4Gw }}
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>
        <!-- WAN IPアドレス(IPv6) : 契約情報がIPV4以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV4' &&
            nwSettingDetail.networkIpSettingSby
          "
        >
          <v-row>
            <v-col>
              <app-label-group label="WAN IPアドレス(IPv6)">
                <template #value>
                  <small>GW対向ルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingSby.wanIpv6Pe }}
                  </div>
                  <small>GWルータ</small>
                  <div class="ml-3">
                    {{ nwSettingDetail.networkIpSettingSby.wanIpv6Gw }}
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
        </template>
        <!-- DNS IPアドレス(IPv4) : 契約情報がIPV6以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV6' &&
            nwSettingDetail.networkIpSettingSby
          "
        >
          <v-row>
            <v-col>
              <app-label-group
                label="DNS IPアドレス(IPv4)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.networkIpSettingSby.dnsIpv4,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>
        <!-- DNS IPアドレス(IPv6) : 契約情報がIPV4以外の場合に表示 -->
        <template
          v-if="
            cpaContractInfo.ipAddressType !== 'IPV4' &&
            nwSettingDetail.networkIpSettingSby
          "
        >
          <v-row>
            <v-col>
              <app-label-group
                label="DNS IPアドレス(IPv6)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.networkIpSettingSby.dnsIpv6,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>

    <!-- アイドルタイマ -->
    <v-row>
      <v-col>
        <app-label-group label="アイドルタイマ">
          <template #value>
            <div class="ml-3">
              <span
                :class="
                  isUpdateRequiredRed && nwOptions.idleTimer === 'UPDATE'
                    ? 'color-highlight'
                    : ''
                "
              >
                {{ nwSettingDetail.idleTimer }}
              </span>
            </div>
          </template>
        </app-label-group>
      </v-col>
    </v-row>

    <!-- 保守連絡先 -->
    <v-row class="mt-3">
      <!-- 保守連絡先① -->
      <v-col cols="6" v-if="nwSettingDetail.maintenanceContact1">
        <v-row>
          <v-col>
            <h3>保守連絡先①</h3>
          </v-col>
        </v-row>
        <!-- 会社名/部署名 -->
        <v-row>
          <v-col>
            <app-label-group
              label="会社名/部署名"
              :value="nwSettingDetail.maintenanceContact1.company"
            />
          </v-col>
        </v-row>
        <!-- 担当者名 -->
        <v-row>
          <v-col>
            <app-label-group
              label="担当者名"
              :value="nwSettingDetail.maintenanceContact1.name"
            />
          </v-col>
        </v-row>
        <!-- 電話番号 -->
        <v-row>
          <v-col>
            <app-label-group
              label="電話番号"
              :value="nwSettingDetail.maintenanceContact1.phone"
            />
          </v-col>
        </v-row>
        <!-- メールアドレス -->
        <v-row>
          <v-col>
            <app-label-group
              label="メールアドレス"
              :value="nwSettingDetail.maintenanceContact1.email"
            />
          </v-col>
        </v-row>
      </v-col>

      <!-- 保守連絡先② -->
      <v-col
        cols="6"
        v-if="
          nwSettingDetail.maintenanceContact2 &&
          nwSettingDetail.maintenanceContact2.company
        "
      >
        <v-row>
          <v-col>
            <h3>保守連絡先②</h3>
          </v-col>
        </v-row>
        <!-- 会社名/部署名 -->
        <v-row>
          <v-col>
            <app-label-group
              label="会社名/部署名"
              :value="nwSettingDetail.maintenanceContact2.company"
            />
          </v-col>
        </v-row>
        <!-- 担当者名 -->
        <v-row>
          <v-col>
            <app-label-group
              label="担当者名"
              :value="nwSettingDetail.maintenanceContact2.name"
            />
          </v-col>
        </v-row>
        <!-- 電話番号 -->
        <v-row>
          <v-col>
            <app-label-group
              label="電話番号"
              :value="nwSettingDetail.maintenanceContact2.phone"
            />
          </v-col>
        </v-row>
        <!-- メールアドレス -->
        <v-row>
          <v-col>
            <app-label-group
              label="メールアドレス"
              :value="nwSettingDetail.maintenanceContact2.email"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- その他項目 -->
    <v-row class="mt-3" v-if="!hideOtherOptions">
      <v-col>
        <v-row>
          <v-col>
            <h3>その他項目</h3>
          </v-col>
        </v-row>
        <!-- 案件コード -->
        <v-row
          v-if="
            cpaContractInfo.contractType === 'CPA_LIMIT_MODULE' &&
            cpaContractInfo.authenticationType !== 'HOMERADIUS'
          "
        >
          <v-col>
            <app-label-group label="案件コード">
              <template #value>
                <div
                  class="ml-3 deal-code-list-scroll text-monospace d-flex flex-wrap"
                >
                  <span
                    class="mr-4"
                    v-for="(code, index) in nwSettingDetail.dealCodeList"
                    :key="index"
                  >
                    {{ code }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- 折り返し通信 -->
        <v-row
          v-if="
            nwOptions.wrapCommunication === 'UPDATE' ||
            nwOptions.wrapCommunication === 'APPLIED'
          "
        >
          <v-col>
            <app-label-group label="折り返し通信">
              <template #value>
                <div class="ml-3">
                  <span
                    :class="
                      isUpdateRequiredRed &&
                      nwOptions.wrapCommunication === 'UPDATE'
                        ? 'color-highlight'
                        : ''
                    "
                  >
                    {{
                      $filter.enumTo(
                        nwSettingDetail.isWrapCommunication,
                        "cpaSettingFlg"
                      )
                    }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- FTP送信 -->
        <v-row
          v-if="
            nwOptions.ftpSendSetting === 'UPDATE' ||
            nwOptions.ftpSendSetting === 'APPLIED'
          "
        >
          <v-col>
            <app-label-group label="FTP送信">
              <template #value>
                <div class="ml-3">
                  <span
                    :class="
                      isUpdateRequiredRed &&
                      nwOptions.ftpSendSetting === 'UPDATE'
                        ? 'color-highlight'
                        : ''
                    "
                  >
                    {{
                      $filter.enumTo(
                        nwSettingDetail.isFtpSending,
                        "cpaSettingFlg"
                      )
                    }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- カスコンクライアントIPアドレス -->
        <v-row
          v-if="
            nwOptions.cusconClientIp === 'UPDATE' ||
            nwOptions.cusconClientIp === 'APPLIED'
          "
        >
          <v-col>
            <app-label-group label="カスコンクライアントIPアドレス">
              <template #value>
                <div class="ml-3">
                  <span
                    :class="
                      isUpdateRequiredRed &&
                      nwOptions.cusconClientIp === 'UPDATE'
                        ? 'color-highlight'
                        : ''
                    "
                  >
                    {{ $filter.emptyTo(nwSettingDetail.cusconClientIp, "-") }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- AlwaysON -->
        <v-row
          v-if="
            nwOptions.alwaysOn === 'UPDATE' || nwOptions.alwaysOn === 'APPLIED'
          "
        >
          <v-col>
            <app-label-group label="AlwaysON">
              <template #value>
                <div class="ml-3">
                  <span
                    :class="
                      isUpdateRequiredRed && nwOptions.alwaysOn === 'UPDATE'
                        ? 'color-highlight'
                        : ''
                    "
                  >
                    {{
                      $filter.enumTo(
                        nwSettingDetail.isAlwaysOn,
                        "cpaSettingFlg"
                      )
                    }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- 長時間呼切断タイマ -->
        <v-row
          v-if="
            nwOptions.longTimeCallDisconnectTimer === 'UPDATE' ||
            nwOptions.longTimeCallDisconnectTimer === 'APPLIED'
          "
        >
          <v-col>
            <app-label-group label="長時間呼切断タイマ">
              <template #value>
                <div class="ml-3">
                  <span
                    :class="
                      isUpdateRequiredRed &&
                      nwOptions.longTimeCallDisconnectTimer === 'UPDATE'
                        ? 'color-highlight'
                        : ''
                    "
                  >
                    {{ nwSettingDetail.longTimeCallDisconnectTimer }}
                  </span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>

        <template
          v-if="
            (cpaContractInfo.authenticationType === 'HOMERADIUS' ||
              cpaContractInfo.authenticationType === 'HOME') &&
            nwSettingDetail.radiusSetting
          "
        >
          <!-- Home RADIUS/Accounting Server IPアドレス(Primary) -->
          <v-row>
            <v-col>
              <app-label-group
                label="Home RADIUS/Accounting Server IPアドレス(Primary)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.radiusSetting.ipAddressPrimary,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- Home RADIUS/Accounting Server IPアドレス(Secondary) -->
          <v-row>
            <v-col>
              <app-label-group
                label="Home RADIUS/Accounting Server IPアドレス(Secondary)"
                :value="
                  $filter.emptyTo(
                    nwSettingDetail.radiusSetting.ipAddressSecondary,
                    '-'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- Secretkey -->
          <v-row>
            <v-col>
              <app-label-group
                label="Secretkey"
                :value="nwSettingDetail.radiusSetting.secretKey"
              />
            </v-col>
          </v-row>
          <!-- ドメイン情報送出 -->
          <v-row>
            <v-col>
              <app-label-group
                label="ドメイン情報送出"
                :value="
                  $filter.enumTo(
                    nwSettingDetail.radiusSetting.isDomainInfoSending,
                    'cpaSettingFlg'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- 課金パケット送出 -->
          <v-row>
            <v-col>
              <app-label-group
                label="課金パケット送出"
                :value="
                  $filter.enumTo(
                    nwSettingDetail.radiusSetting.isBillingPacketSending,
                    'cpaSettingFlg'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- UDPポート番号(認証/課金) -->
          <v-row>
            <v-col>
              <app-label-group
                label="UDPポート番号(認証/課金)"
                :value="
                  $filter.enumTo(
                    nwSettingDetail.radiusSetting.udpPort,
                    'cpaUdpPort'
                  )
                "
              />
            </v-col>
          </v-row>
          <!-- CallingStationID転送 -->
          <v-row
            v-if="
              nwOptions.callingStationIdTransfer === 'UPDATE' ||
              nwOptions.callingStationIdTransfer === 'APPLIED'
            "
          >
            <v-col>
              <app-label-group label="CallingStationID転送">
                <template #value>
                  <div class="ml-3">
                    <span
                      :class="
                        isUpdateRequiredRed &&
                        nwOptions.callingStationIdTransfer === 'UPDATE'
                          ? 'color-highlight'
                          : ''
                      "
                    >
                      {{
                        $filter.enumTo(
                          nwSettingDetail.radiusSetting
                            .callingStationIdTransfer,
                          "cpaCallingStation"
                        )
                      }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>
          <!-- IMEI転送 -->
          <v-row
            v-if="
              nwOptions.imeiTransfer === 'UPDATE' ||
              nwOptions.imeiTransfer === 'APPLIED'
            "
          >
            <v-col>
              <app-label-group label="IMEI転送">
                <template #value>
                  <div class="ml-3">
                    <span
                      :class="
                        isUpdateRequiredRed &&
                        nwOptions.imeiTransfer === 'UPDATE'
                          ? 'color-highlight'
                          : ''
                      "
                    >
                      {{
                        $filter.enumTo(
                          nwSettingDetail.radiusSetting.isImeiTransfer,
                          "cpaImeiTransfer"
                        )
                      }}
                    </span>
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>

          <!-- テストアカウント -->
          <template v-if="cpaContractInfo.ipAddressType !== 'IPV6'">
            <v-row class="mt-3">
              <v-col>
                <v-row>
                  <v-col>
                    <h3>テストアカウント</h3>
                  </v-col>
                </v-row>
                <!-- ユーザID -->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="ユーザID"
                      :value="
                        nwSettingDetail.radiusSetting.testAccount
                          ? $filter.emptyTo(
                              nwSettingDetail.radiusSetting.testAccount
                                .testUserId,
                              '-'
                            )
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
                <!-- PASS -->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="PASS"
                      :value="
                        nwSettingDetail.radiusSetting.testAccount
                          ? $filter.emptyTo(
                              nwSettingDetail.radiusSetting.testAccount
                                .testPassword,
                              '-'
                            )
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
                <!-- テスト用IP -->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="テスト用IP"
                      :value="
                        nwSettingDetail.radiusSetting.testAccount
                          ? $filter.emptyTo(
                              nwSettingDetail.radiusSetting.testAccount.testIp,
                              '-'
                            )
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CpaContract, CpaNwDetail, CpaNwOptions } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaNwSettingInfo",
  props: {
    /** CPA契約情報 */
    cpaContractInfo: {
      type: Object as PropType<CpaContract>,
      required: true,
    },
    /** CPA NW 詳細情報 */
    nwSettingDetail: {
      type: Object as PropType<CpaNwDetail>,
      required: true,
    },
    /** CPA特殊項目設定情報 */
    nwOptions: {
      type: Object as PropType<CpaNwOptions>,
      required: true,
    },
    /** データ更新要反映の赤文字表示する為のフラグ */
    isUpdateRequiredRed: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    /** 帯域情報表示フラグ */
    isShowBandwidthInfo: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    /** 端末割当アドレス(IPv4)ソートフラグ */
    isSortUeIpAllocationIpv4List: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * その他項目（タイトルも含めて）表示・非表示フラグ
     * true: 非表示 false: 表示
     */
    hideOtherOptions(): boolean {
      return (
        (this.cpaContractInfo.contractType === "CPA_NO_LIMIT" ||
          this.cpaContractInfo.contractType === "CPA_LIMIT_AUDIO") &&
        (this.cpaContractInfo.authenticationType === "RADIUS" ||
          this.cpaContractInfo.authenticationType === "RADIUS_IMEI") &&
        !this.nwOptions.wrapCommunication &&
        !this.nwOptions.ftpSendSetting &&
        !this.nwOptions.cusconClientIp &&
        !this.nwOptions.alwaysOn &&
        !this.nwOptions.longTimeCallDisconnectTimer
      );
    },
    /**
     * 端末割当アドレス(IPv4)を表示用に返す
     */
    sortedUeIpAllocationIpv4List(): string[] {
      if (this.isSortUeIpAllocationIpv4List) {
        return (
          this.nwSettingDetail.ueIpAllocationIpv4List?.sortIpAddress?.() ?? []
        );
      } else {
        return this.nwSettingDetail.ueIpAllocationIpv4List ?? [];
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.color-highlight {
  color: #dc3545;
}
.deal-code-list-scroll {
  // 5行目が半分で切れるサイズ
  max-height: 107px;
  overflow: scroll;
}
.ipv4-display {
  display: inline-block;
  width: 160px;
}
.ipv6-display {
  display: inline-block;
  width: 435px;
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace !important;
}
</style>
